import { create } from 'zustand'
import { gridConfigurationService } from '@/services/grid-configuration.service'
import { ColDef } from 'ag-grid-community'

export type GridState = { [collection: string]: Collection }

export type Collection = {
  selected: string
  state: CollectionState
  filter?: CollectionFilter
}

export type CollectionState = { [viewName: string]: ColDef[] }
export type CollectionFilter = { [viewName: string]: GridFilterModel }
export type GridFilterModel = { [field: string]: any }

interface GridConfigurationState {
  gridConfiguration: GridState
  isLoading: boolean
  isInitialized: boolean
  fetchGridConfiguration: () => Promise<void>
  updateGridConfiguration: (collection: string, collectionState: Collection) => void
  saveGridConfiguration: () => Promise<void>
  getCollectionState: (collection: string) => Collection | undefined
}

export const useGridConfigurationStore = create<GridConfigurationState>((set, get) => ({
  gridConfiguration: {},
  isLoading: false,
  isInitialized: false,

  fetchGridConfiguration: async () => {
    if (get().isInitialized) return

    set({ isLoading: true })
    try {
      const config = await gridConfigurationService.getGridConfiguration()
      set({ gridConfiguration: config, isInitialized: true })
    } catch (error) {
      console.error('Error fetching grid configuration:', error)
      set({ gridConfiguration: {}, isInitialized: true })
    } finally {
      set({ isLoading: false })
    }
  },

  updateGridConfiguration: (collection: string, collectionState: Collection) => {
    const current = get().gridConfiguration
    set({
      gridConfiguration: {
        ...current,
        [collection]: collectionState,
      },
    })
  },

  saveGridConfiguration: async () => {
    try {
      await gridConfigurationService.saveGridConfiguration(get().gridConfiguration)
    } catch (error) {
      console.error('Error saving grid configuration:', error)
      throw error
    }
  },

  getCollectionState: (collection: string) => {
    return get().gridConfiguration[collection]
  },
}))


